import Select from 'common/components/form/inputs/Select';

import { portSizeOptions } from 'views/enums/ports/form/port/options';

const PortTypeSelector = ({ isMulti, filter, value, label, onChange }) => {
  return (
    <Select
      label={label}
      placeholder={'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={portSizeOptions}
      isMulti={isMulti}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        })
      }
      isClearable
    />
  );
};

export default PortTypeSelector;
